import { IAnyType } from 'common/types/common';
import { normalizeLocalizedHref } from 'common/utils/url';
import NextLink from 'next/link';
import { useTranslation } from 'next-i18next';

export const Link = ({ className, href, children, ...rest }: IAnyType) => {
  const { i18n } = useTranslation();
  const normalizedHref =
    typeof href === 'string' ? normalizeLocalizedHref(href, i18n.language) : href;

  return (
    <NextLink href={normalizedHref} className={className} {...rest}>
      {children}
    </NextLink>
  );
};
